export const getResolutionFromDimensions = (
  height: number,
  width: number
): string => {
  if (width >= 3840 && height >= 2160) return '4K';
  if (width >= 2560 && height >= 1440) return '2K';
  if (width >= 1920 && height >= 1080) return '1080P';
  if (width >= 1280 && height >= 720) return '720P';
  if (width >= 854 && height >= 480) return '480P';
  if (width >= 640 && height >= 360) return '360P';

  // If resolution is lower than 360p, return the actual dimensions
  return `${width}x${height}`;
};

export default getResolutionFromDimensions;
